import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import * as echarts from 'echarts/lib/echarts';
import echartsColorTheme from '../echartsColorTheme';

import 'echarts/lib/chart/graph';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/toolbox';

// lag order is 2 of the granger test
const allLinks = [{
  source: 0,
  target: 2,
  label: {
    show: true,
    formatter: '0.062',
  },
  lineStyle: {
    width: 1.5,
    curveness: 0.25
  }
}, {
  source: 2,
  target: 1,
  label: {
    show: true,
    formatter: '0.030',
  },
  lineStyle: {
    width: 3,
    curveness: 0.15
  }
}, {
  source: 1,
  target: 4,
  label: {
    show: true,
    formatter: '0.002',
  },
  lineStyle: {
    width: 5,
    curveness: -0.15
  }
}, {
  source: 0,
  target: 3,
  label: {
    show: true,
    formatter: '0.085',
  },
  lineStyle: {
    width: 1,
    curveness: 0.2
  }
}, {
  source: 2,
  target: 4,
  label: {
    show: true,
    formatter: '0.046',
  },
  lineStyle: {
    width: 2,
    curveness: 0.3
  }
}];

const ThresholdButton = (props) => {
  return (
    <div>
      <div class="d-flex justify-content-center">
        <h5><i>p</i>-value threshold</h5>
      </div>
      <div class="d-flex justify-content-center" style={{ marginBottom: '25px' }}>
        <ButtonGroup>
          <Button outline color="secondary" onClick={() => props.onClick('0.01')} active={props.selectedButton === '0.01'}>{'< 0.01'}</Button>
          <Button outline color="secondary" onClick={() => props.onClick('0.05')} active={props.selectedButton === '0.05'}>{'< 0.05'}</Button>
          <Button outline color="secondary" onClick={() => props.onClick('0.1')} active={props.selectedButton === '0.1'}>{'< 0.1'}</Button>
        </ButtonGroup>
      </div>
    </div>
  )
}

class GrangerTestGraph extends React.Component {
  constructor(props) {
    super(props);
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = null;
    this.state = {
      selectedButton: '0.1'
    }

    this.setButtonSelected = this.setButtonSelected.bind(this);
  }

  setButtonSelected(value) {
    var newLinks = allLinks.filter((link) => parseFloat(link['label']['formatter']) < parseFloat(value));
    this.myChart.setOption({
      series: {
        links: newLinks
      }
    });
    this.setState({
      selectedButton: value
    });
  }

  componentDidMount() {
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = echarts.init(document.getElementById('granger-test-graph'), 'customColorTheme', 'EN');
    var option = {
      // tooltip: {},
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        left: 'center',
        width: '80%',
        // top: '5%',
        // height: '80%',
      },
      animationDurationUpdate: 1500,
      animationEasingUpdate: 'quinticInOut',
      series: {
        type: 'graph',
        layout: 'none',
        itemStyle: {
          color: '#ffffff',
          borderColor: '#7952b3',
          borderWidth: 1.5
        },
        center: [125, 75],
        symbolSize: 50,
        roam: false,
        label: {
          show: true,
          fontSize: 12
        },
        edgeSymbol: ['circle', 'arrow'],
        edgeSymbolSize: [4, 10],
        edgeLabel: {
          fontSize: 14
        },
        data: [{
          name: 'Maqu\nCounty',
          x: 10,
          y: 150,
          symbolSize: 80,
          itemStyle: {
            borderWidth: 4
          },
          label: {
            fontSize: 18,
          },
        }, {
          name: 'Luqu\nCounty',
          x: 100,
          y: 100,
          symbolSize: 70,
          itemStyle: {
            borderWidth: 3
          },
          label: {
            fontSize: 16,
          },
        }, {
          name: 'Xiahe\nCounty',
          x: 100,
          y: 0,
          symbolSize: 70,
          itemStyle: {
            borderWidth: 3
          },
          label: {
            fontSize: 16,
          },
        }, {
          name: 'Hezuo\nCity',
          x: 150,
          y: 50,
          symbolSize: 60,
          itemStyle: {
            borderWidth: 2
          },
          label: {
            fontSize: 14,
          },
        }, {
          name: 'Zhuoni\nCounty',
          x: 200,
          y: 100
        }, {
          name: 'Lintan\nCounty',
          x: 250,
          y: 75
        }],
        links: allLinks,
        lineStyle: {
          opacity: 0.9,
          color: '#7a7089'
        }
      },
    };
    this.myChart.setOption(option);
  }

  componentDidUpdate() {
    this.myChart.resize();
  }

  render() {
    return (
      <>
        <ThresholdButton onClick={this.setButtonSelected} selectedButton={this.state.selectedButton} />
        <div class="m-auto" id="granger-test-graph" style={{ height: '500px' }}></div>
      </>
    );
  }
}

export default GrangerTestGraph;